import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Sparkles, Mail } from 'lucide-react';
import { useAuth } from '../../../../context/AuthContext';

const COPY = {
    subscription: {
        description: (name) => `Your current plan doesn't include ${name}.`,
        ctaLabel: 'Upgrade your plan',
        ctaIcon: Sparkles
    },
    role: {
        description: (name) => `Your role doesn't have access to ${name} yet.`,
        ctaLabel: 'Ask your administrator',
        ctaIcon: Mail
    },
    client: {
        description: (name) => `${name} isn't enabled for your organization.`,
        ctaLabel: 'Contact your administrator',
        ctaIcon: Mail
    }
};

export default function LockCard({ featureName, reason }) {
    const { currentUser } = useAuth();
    const config = COPY[reason] || COPY.subscription;
    const Icon = config.ctaIcon;

    const ctaTarget = reason === 'subscription'
        ? '/dashboard/upgrade'
        : currentUser?.clientAdminEmail
            ? `mailto:${currentUser.clientAdminEmail}?subject=${encodeURIComponent(`Access request: ${featureName}`)}&body=${encodeURIComponent(`Hi,\n\nI'd like to request access to ${featureName} in JPRO.\n\nThanks.`)}`
            : null;

    return (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="pointer-events-auto bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 p-8 max-w-md w-full mx-4 text-center space-y-5">
                <div className="mx-auto w-14 h-14 rounded-full bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center">
                    <Lock size={26} className="text-blue-600 dark:text-blue-400" />
                </div>
                <div className="space-y-2">
                    <h2 className="text-xl font-unna font-semibold text-gray-900 dark:text-gray-100">
                        {featureName}
                    </h2>
                    <p className="font-rasa text-gray-600 dark:text-gray-300">
                        {config.description(featureName)}
                    </p>
                </div>
                {ctaTarget ? (
                    reason === 'subscription' ? (
                        <Link
                            to={ctaTarget}
                            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-rasa shadow-lg hover:shadow-xl transition-all"
                        >
                            <Icon size={16} />
                            {config.ctaLabel}
                        </Link>
                    ) : (
                        <a
                            href={ctaTarget}
                            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-rasa shadow-lg hover:shadow-xl transition-all"
                        >
                            <Icon size={16} />
                            {config.ctaLabel}
                        </a>
                    )
                ) : (
                    <p className="text-sm text-gray-500 dark:text-gray-400 font-rasa">
                        Reach out to your administrator for access.
                    </p>
                )}
            </div>
        </div>
    );
}
